const prediggoTranslation = {
  'cultureType': 'vis-kun',
  'cultureType/Bio': 'vis-kun/oko',
  'cultureType/Sans%20r%E9sidu%20de%20pesticide': 'vis-kun/ingen-pesticidrester',
  'cultureType/Sans%20OGM': 'vis-kun/gmo-fri',
};

export default prediggoTranslation;
